import { StyleSheet } from 'react-native'

// styles
import { colorPalette } from './global'

const skeletonStyles = StyleSheet.create({
  // header
  headerNav: {
    backgroundColor: colorPalette.white,
    opacity: 0.2,
    width: '20%',
    padding: 5,
    borderRadius: 10,
    marginTop: 10,
    marginBottom: 20
  },
  headerHeading: {
    backgroundColor: colorPalette.white,
    opacity: 0.2,
    width: '70%',
    padding: 8,
    borderRadius: 10,
    marginBottom: 20
  },
  headerDescription: {
    backgroundColor: colorPalette.white,
    opacity: 0.2,
    width: '100%',
    padding: 5,
    borderRadius: 10,
    marginBottom: 10
  }
})

export { skeletonStyles }
